import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { decodeQuery } from '@swf/core/utils';

const useCMSHeaderAndGridLayout = () => {
  const [query] = Object.keys(useSelector(select.location.getQuery));
  const depositResultContext = query && decodeQuery(query);
  const cmsHeaderAndGridLayout =
    !depositResultContext ||
    depositResultContext.cmsHeaderAndGridLayout === true ||
    depositResultContext.cmsHeaderAndGridLayout === 'true';

  return cmsHeaderAndGridLayout;
};

export default useCMSHeaderAndGridLayout;
